import Vue from 'vue';
import VuePageTitle from 'vue-page-title';

Vue.use(VuePageTitle);

// TODO: review use
